module.exports = __webpack_public_path__ + "static/media/external-link.be858752.svg";